export default __webpack_public_path__ + "static/media/flag-tanzania.fe228584.png";